import { useI18n } from '@change-corgi/core/react/i18n';
import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { calculateImpressions } from 'src/app/shared/utils/promote';

import { usePromoteFormData } from '../../../formContext/formData';
import { usePromoteFormState } from '../../../formContext/formState';

export function useSetReceiptCookie(): (membershipAmount: number) => void {
	const { cookies, userAgent } = useUtilityContext();
	const { amountToBaseUnits } = useI18n();

	const {
		promotionSettings: { cpm, bonusCpm, bonusThreshold },
		currency,
		petition: { ask, slug },
	} = usePromoteFormData();
	const [{ amount }] = usePromoteFormState();

	return function setReceiptCookie(membershipAmount) {
		const promotionAmountCents = amountToBaseUnits(amount, currency.code);
		const impressions = calculateImpressions(amountToBaseUnits(amount, currency.code), cpm, bonusCpm, bonusThreshold);
		const thankYouCookieValue = JSON.stringify({
			promotionAmount: amount,
			promotionAmountCents,
			impressions,
			petitionTitle: ask,
			membershipAmount,
			membershipAmountCents: amountToBaseUnits(membershipAmount, currency.code),
			currencyCode: currency.code,
			date: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(),
			slug,
		});
		const IN_90_SECONDS = 1 / 960;
		const parsedUserAgent = userAgent.getParsedUserAgent();
		// Skipping cookie expiry setting for firefox. It is not removing expired cookies.
		// When we set this cookie next time, with up to date expiry date,
		// firefox still treats it like it is expired.
		const expiry = parsedUserAgent.getBrowser().name === 'Firefox' ? undefined : { expires: IN_90_SECONDS, path: '/' };
		cookies.set('app_meta_ppmu_ty_receipt', thankYouCookieValue, expiry);
	};
}
